import React from 'react'
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom'
import AdminHomeHelper from '../../Components/AdminHomeHelper'

const AdminHome = () => {
    const store = useSelector((store) => store)

    const history = useHistory()
    return (
        <div>
           
            {store.admin.isAuthenticated ? <>
                
                <div className="container-fluid p-0">
                    <div className="d-flex">
                    <div className="print-helper">
                            <AdminHomeHelper />
                        </div>
                        <div className="mx-1 w-100 ">
                            <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
                                <h3> <img src="logo192.png" width={'50px'} alt="" /> MY PROFILE</h3>
                                <button onClick={()=> window.print()} type="button" className=" btn-success btn text-light"> <img src="/image/print.svg" lt="" /> Download</button>
                            </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="card" >
                                            <img className="card-img-top img-fluid" src={store.admin.admin.avatar} alt="Card image" />
                                                <div className="card-body">
                                                    <h5 className="card-title bg-dark text-light p-2">{store.admin.admin.name}</h5>
                                                    <div className="w-100">
                                                    <h6 className='d-flex align-items-center'><img src="/image/mail.svg" alt="" className='p-1' />{store.admin.admin.name}</h6>
                                                    <h6 className='d-flex align-items-center'><img src="/image/phone.svg" alt="" className='p-1' />{store.admin.admin.contactNumber}</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-8">
                                        <table className="table border table table-striped table-bordered">
                                            <tbody>
                                                <tr>
                                                    <td>Name</td>
                                                    <td>{store.admin.admin.name}</td>
                                                </tr>
                                                <tr>
                                                    <td>Email</td>
                                                    <td>{store.admin.admin.email}</td>
                                                </tr>
                                                <tr>
                                                    <td>Registration Number</td>
                                                    <td>{store.admin.admin.registrationNumber}</td>
                                                </tr>
                                                <tr>
                                                    <td>Joining Year</td>
                                                    <td>{store.admin.admin.joiningYear}</td>
                                                </tr>
                                                <tr>
                                                    <td>Department</td>
                                                    <td>{store.admin.admin.department}</td>
                                                </tr>
                                                <tr>
                                                    <td>Contact Number</td>
                                                    <td>{store.admin.admin.contactNumber ?
                                                        store.admin.admin.contactNumber : "NA"}</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
                </> : (history.push('/'))}
                
        </div>
    )
}

export default AdminHome
